import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { isDocumentNumberField } from "@Helpers/constants";
import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
import ToggleSwitchComponent from "@CubeComponents/form/ToggleSwitchComponent";
import { formatBytes, containerFileTypes, modulesNameSynonymMapper, TOAST_TYPE_ERROR } from "@Services/constants";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { useDispatch } from "react-redux";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import IconComponent from "@CubeComponents/icons";
import FileManagerComponent from "@CubeComponents/FileManager/FileManagerComponent";
import _ from "lodash";
import { Box, Divider, Fade, FormControl, Menu, MenuItem, Select, Tab, Tabs } from "@mui/material";
import CreateReviewModal from "@Features/reviews/CreateReviewModal";
import ReviewsList from "@Features/reviews/ReviewsList";
import { FileConversionStatus } from "@Features/files";
import FileDelete from "./FileDelete/FileDelete";
import ExcelImport from "@Components/ExcelImport/ExcelImport";
import { excelImportSources } from "@Components/ExcelImport/ExcelHelper";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import Text from "@CubeComponents/html/Text/Text";
import CreateTransmittal from "@Features/transmittals/pages/Transmitals/CreateTransmittal/CreateTransmittal";
import { convertDate } from "@Services/luxonHelper";
import { portalCreateRoot as createRoot } from "@CubeComponents/html/cellPortals";
import { getFileIcon, getIconbasedOnResourceType } from "@CubeComponents/constants/globalFunctions";
import { NomenclatureField } from "@Services/utils/useCustomFields";
import FormPreview from "@Features/portal-settings/components/PortalSetings/Configuration/FormsAndFields/FormTemplate/formPreview";
import FileManagerAsPopup from "./FileManagerAsPopup";
import "./FileManagerNew.css";
import FolderSyncTemplate from "./FolderSyncTemplate";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import useFileManager, { TAB_THIS_SPACE, TAB_EXTERNAL_SPACE, TAB_REVIEWS } from "./useFileManager";
import { showToastNotification } from "@Reducers/toastSlice";
import { hasInvalidChars } from "@Helpers/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { getSubColumns } from "@CubeComponents/html/SlickGrid1/customFields";
import { getStatusBtnStyle } from "@Features/reviews/helpers";
import Forbidden from "@Pages/Error/Forbidden";

interface FileManagerProps {
  defaultSelectedTab?: string;
  fileManagerAsPopup?: boolean;
  spaceId: string;
  projectId: string;
  showOnlyMergedFile?: boolean;
  setShowProperties?: any;
  mobileFileManager?: boolean;
  hideExternalSpace?: boolean;
  hideReviews?: boolean;
  hideAllTabs?: boolean;
  enableSpaceListDropdown?: boolean;
  openThisSpaceByDefault?: boolean;
  createShortcut?: boolean;
  showFolderTree?: boolean;
  handleFileSelectionCallback?: (files: any[]) => void;
  hideIssues?: boolean;
  hideTasks?: boolean;
  hideEstimates?: boolean;
  hideClashTests?: boolean;
  hideContracts?: boolean;
  hideSchedules?: boolean;
  useAttachedExternalVolume?: boolean;
  hideMergeFiles?: boolean;
  disableContextMenu?: boolean;
  disableFiles?: any[];
  enableOnlyShareableResources?: boolean;
  hideUpload?: boolean;
  enableFilesTypes?: string[] | null;
  hideShortcuts?: boolean;
  handleFolderSelectionCallback?: (folder: any) => void;
  setSpaceId?: (id: any) => void;
  alreadySelected?: any[] | null;
  showExcelImport?: boolean;
  defaultPath?: string;
  allowFolderSelectionCallback?: boolean;
  spaceList?: any[];
  disableDragAndDropUpload?: boolean;
  hideFilesWithoutVersion?: boolean;
}

export interface FileManagerHandle {
  updateRowCustomFields: (rowId: string, changes: Record<string, unknown>) => void;
}

const FileManager = React.forwardRef<FileManagerHandle, FileManagerProps>((props, ref) => {
  const dispatch = useDispatch<any>();
  const { disableFiles, hideFilesWithoutVersion } = props;
  const navigate = useNavigate();
  const location = useLocation();

  const {
    fileManagerRef,
    formValidator,
    pollingRef,

    fileManagerData,
    setFileManagerData,
    showContainerImportModal,
    setShowContainerImportModal,
    importMode,
    openRenameModal,
    setOpenRenameModal,
    selectedFile,
    newName,
    setNewName,
    folderName,
    createReviewModal,
    openMergeModal,
    openMergeEstimateModal,
    emptyThisSpace,
    emptyExternal,
    openFolderCreationModal,
    openFileImport,
    openContainerModal,
    currentFolder,
    setCurrentFolder,
    selectedFilesToDelete,
    openDeleteConfirmationModal,
    openCreateTransmittalModal,
    setOpenCreateTransmittalModal,
    containerFormTemplate,
    fileTypeValue,
    resourceType,
    setResourceType,
    containerName,
    path,
    preSearchText,
    toolBarBtnState,
    selectedTab,
    shortCutData,
    openFileModalExternal,
    anchorEl,
    open,
    importSubmenuAnchor,
    importSubmenuOpen,

    layout,
    getSpaceToggle,
    userDetails,
    isFileVersionUploading,
    spaceData,
    handleDeleteModalClose,
    handleDeleteSuccess,
    getSelectedFilesInFileManager,
    getPermission,
    beforeSending,
    handleEmptyStateDrop,
    handleEmptyStateDragOver,
    handleSpaceSelect,
    handleSpaceToggle,
    handleDetailIconClick,
    handleSelectOption,
    handleClick,
    handleClose,
    handleImportSubmenuOpen,
    handleImportSubmenuClose,
    closeReviewModal,
    onFileSelect,
    onFileClick,
    toolbarClick,
    onSuccess,
    saveFileMergeModal,
    closeFileMergeModal,
    closeCreateShortcutModal,
    closeFileImportPopup,
    closeMergeEstimateModal,
    handleFileImportCallback,
    createMergeEstimateModal,
    onFileLoad,
    handleNoDataRefresh,
    handleModalClose,
    handleCreateContainer,
    handleSaveNewName,
    handleCloseFolder,
    handleFolderName,
    handleCustomFieldsData,
    handleEmbedUrl,
    handleContainerName,
    handleCreateFolder,
    handleNomenclatureChange,
    nomenclatureValues,
    menuOpen,
    handleFileManagerTabClick,
    setFileTypeValue,

    fileManagerOptionsMapper,
    dropDownButtonItems,

    fileManagerAsPopup,
    hideAllTabs,
    hideExternalSpace,
    hideReviews,
    enableSpaceListDropdown,
    disableContextMenu,
    showFolderTree,
    disableDragAndDropUpload,
    spaceList,
    spaceId,
    projectId,
    reloadFileManager,
    t,
  } = useFileManager({ ...props, navigate, location });

  useImperativeHandle(
    ref,
    () => ({
      updateRowCustomFields: (rowId: string, changes: Record<string, unknown>) => {
        if (!rowId || !changes) return;
        const grid: any = fileManagerRef.current;
        const slickGrid: any = grid?.slickGrid;

        const dataView: any = grid?.dataView ?? slickGrid?.getData?.();
        if (!slickGrid || !dataView) return;
        const id = String(rowId);
        const existing =
          typeof dataView.getItemById === "function"
            ? dataView.getItemById(id)
            : (dataView.getItems?.() ?? dataView.items ?? []).find((x: any) => String(x?.id) === id);
        if (!existing) return;
        const updated = _.cloneDeep(existing);
        for (const key of Object.keys(changes)) {
          _.set(updated, key, changes[key]);
        }
        if (typeof dataView.updateItem === "function") {
          dataView.updateItem(id, updated);
        }
        slickGrid.invalidate();
        slickGrid.render();
      },
    }),
    [fileManagerRef],
  );

  const fileManagerDataWithDisabled = React.useMemo(() => {
    const hasDisable = Array.isArray(disableFiles) && disableFiles.length > 0;
    if (!hasDisable && !hideFilesWithoutVersion) return fileManagerData;
    const disabledSet = new Set(hasDisable ? disableFiles : []);
    const tag = (file: any) => {
      const shouldDisable =
        hasDisable &&
        ((["RESOURCE_TYPE_FILE", "RESOURCE_TYPE_MERGED_FILE"].includes(file?.resourceType) &&
          disabledSet.has(file.isEmptyContainer ? file.id : file.fileVersion)) ||
          (file?.resourceType === "RESOURCE_TYPE_ISSUE" && disabledSet.has(file.issueVersionId)) ||
          (file?.resourceType === "RESOURCE_TYPE_TASKS" && disabledSet.has(file.taskId)));
      return shouldDisable ? { ...file, isRowDisabled: true } : file;
    };
    const keep = (file: any) => {
      if (!hideFilesWithoutVersion) return true;
      if (file?.resourceType === "RESOURCE_TYPE_FILE" || file?.resourceType === "RESOURCE_TYPE_EMBED") {
        return !file?.isEmptyContainer && !!file?.fileVersion;
      }
      return true;
    };
    const transform = (arr: any[]) => arr.filter(keep).map(tag);
    return {
      ...fileManagerData,
      files: Array.isArray(fileManagerData?.files) ? transform(fileManagerData.files) : fileManagerData?.files,
      filteredFiles: Array.isArray(fileManagerData?.filteredFiles)
        ? transform(fileManagerData.filteredFiles)
        : fileManagerData?.filteredFiles,
    };
  }, [fileManagerData, disableFiles, hideFilesWithoutVersion]);

  const [customFieldColumns, setCustomFieldColumns] = useState<any[]>([]);

  const pinDocumentAndRevisionColumns = !!layout?.FILE_MANAGER?.PIN_DOCUMENT_AND_REVISION_COLUMNS;
  const documentColumn = React.useMemo(
    () => customFieldColumns.find((col: any) => isDocumentNumberField(col?.name)),
    [customFieldColumns],
  );
  const documentColumnId = documentColumn?.id;
  const readDocumentNumber = documentColumn?._valueGetter as ((row: any) => unknown) | undefined;
  const gridRows = fileManagerDataWithDisabled?.files;
  const hasDocumentNumber = React.useCallback(
    (row: any): boolean => {
      const value = readDocumentNumber?.(row);
      return value !== undefined && value !== null && value !== "" && value !== "-";
    },
    [readDocumentNumber],
  );
  const hasAnyDocumentNumber = React.useMemo(() => {
    if (!readDocumentNumber || !Array.isArray(gridRows)) return false;
    return gridRows.some(hasDocumentNumber);
  }, [readDocumentNumber, hasDocumentNumber, gridRows]);
  const showDocumentNumberAsIdentity = pinDocumentAndRevisionColumns && !!documentColumnId && hasAnyDocumentNumber;
  const showRevisionColumn = React.useMemo(() => {
    if (!pinDocumentAndRevisionColumns || !Array.isArray(gridRows)) return false;
    return gridRows.some((row: any) => !!row?.revisionSeries?.label || !!row?.revision);
  }, [pinDocumentAndRevisionColumns, gridRows]);
  const pinnedColumnIds = React.useMemo(() => {
    if (!showDocumentNumberAsIdentity) return [];
    return showRevisionColumn ? [String(documentColumnId), "revision"] : [String(documentColumnId)];
  }, [showDocumentNumberAsIdentity, documentColumnId, showRevisionColumn]);

  useEffect(() => {
    const byFolder = fileManagerData?.customFieldsByFolder;
    const currentId = currentFolder?.id ?? "0";
    const templates: any[] = Array.isArray(byFolder?.[currentId])
      ? byFolder[currentId]
      : Array.isArray(fileManagerData?.customFields)
        ? fileManagerData.customFields
        : [];
    const seen = new Set<string>();
    const columns: any[] = [];
    templates.forEach((item: any) => {
      (item?.template ?? []).forEach((section: any) => {
        getSubColumns(section)?.forEach((col: any) => {
          if (col?.id && !seen.has(col.id)) {
            seen.add(col.id);
            columns.push(col);
          }
        });
      });
    });
    setCustomFieldColumns(columns);
  }, [fileManagerData?.customFieldsByFolder, fileManagerData?.customFields, currentFolder?.id]);

  const statusTemplate = (status: any) => {
    if (!status || status._id === null) return "-";
    const container = document.createElement("div");
    createRoot(container).render(
      <p className="w-fit rounded px-2 py-1 font-semibold text-white" style={getStatusBtnStyle(status.category)}>
        {status.name}
      </p>,
    );
    return container;
  };

  const nameTemplate = (args: any) => {
    const container = document.createElement("div");
    container.classList.add("w-full");
    const root = createRoot(container);
    let content: any = "";
    if (!args.isFormTemplateValid) {
      content = t("Mandatory custom fields not filled.");
    } else if (!args.isFileNomenclatureCorrect) {
      content = t("File name does not comply with File nomenclature set for this Folder. Please rename the file.");
    }
    root.render(
      <Box className="flex items-center flex-row gap-1 justify-between name-td">
        <Text hideToolTip>{args.name}</Text>
        <Box className="flex gap-2">
          {selectedTab == TAB_THIS_SPACE && (
            <>
              {(!args.isFileNomenclatureCorrect || !args.isFormTemplateValid) &&
                args.resourceType !== "RESOURCE_TYPE_TRANSMITTAL" &&
                !args.transmittalVersionId &&
                content && (
                  <IconComponent
                    name={"ErrorIcon"}
                    position="bottom"
                    toolTipContent={content}
                    width="1rem"
                    height="1rem"
                  />
                )}
              <FileConversionStatus ref={pollingRef} {...args} />
            </>
          )}
        </Box>
      </Box>,
    );
    return container;
  };

  const getResourceIcon = (file: any) => {
    const container = document.createElement("div");
    const root = createRoot(container);
    root.render(<Box className="flex gap-2 items-center">{getIconbasedOnResourceType(file)}</Box>);
    return container;
  };

  const fileColumns: any[] = [
    {
      id: "id",
      field: "id",
      name: "",
      formatter: (data: number, params: number, a: any, b: unknown, value: any) => getResourceIcon(value),
      minWidth: 50,
      initiallyHidden: showDocumentNumberAsIdentity,
      excludeFromColumnPicker: true,
      disableGrouping: true,
      disableSorting: true,
      disableFiltering: true,
    },
    {
      id: "name",
      field: "name",
      name: t("Name"),
      minWidth: 250,
      filterType: "Text",
      formatter: (data: number, params: number, a: any, b: unknown, value: any) => nameTemplate(value),
      initiallyHidden: showDocumentNumberAsIdentity,
    },
    {
      id: "dateModified",
      field: "dateModified",
      name: t("Last Modified on"),
      filterType: "Date",
      formatter: (data: number, params: number, a: any, b: unknown, value: any) =>
        convertDate(_.get(value, "dateModified"), "dateForTooltip"),
      minWidth: 150,
    },
    {
      id: "modifiedBy",
      field: "modifiedBy",
      filterType: "Text",
      name: t("Last Modified by"),
      minWidth: 150,
    },
    {
      id: "size",
      field: "size",
      name: t("Size"),
      minWidth: 80,
      filterType: "Number",
      _valueGetter: (value) => (value.size && value.size != "0" ? formatBytes(value.size) : "-"),
      formatter: (data: number, params: number, a: any, b: unknown, value: any) =>
        value.size && value.size != "0" ? formatBytes(value.size) : "-",
    },
    {
      id: "versionNumber",
      field: "versionNumber",
      name: t("Version"),
      filterType: "Number",
      formatter: (data: number, params: number, a: any, b: unknown, value: any) =>
        value.versionNumber ? `V${value.versionNumber}` : "",
      minWidth: 80,
    },
    {
      id: "revision",
      field: "revision",
      name: t("Revision"),
      filterType: "Number",
      initiallyHidden: !showRevisionColumn,
      formatter: (_data: number, _params: number, _a: any, _b: unknown, value: any) =>
        value?.revisionSeries?.label || "-",
      minWidth: 100,
    },
    {
      id: "statusInReviews",
      field: "statusInReviews",
      filterType: "Text",
      name: t("Status"),
      minWidth: 170,
      _valueGetter: (row: any) => row?.statusInReviews?.name || "",
      formatter: (_data: number, _params: number, _a: any, _b: unknown, value: any) =>
        statusTemplate(value?.statusInReviews),
    },
  ];

  const buildGridColumns = () => {
    const allColumns = [...fileColumns, ...customFieldColumns];
    if (!pinDocumentAndRevisionColumns) return allColumns;
    const ordered = [...allColumns];

    if (showDocumentNumberAsIdentity) {
      const documentIndex = ordered.findIndex((col: any) => isDocumentNumberField(col?.name));
      if (documentIndex > 0) {
        const promoted: any = ordered.splice(documentIndex, 1)[0];
        if (promoted) {
          const { columnGroup: _columnGroup, columnGroupId: _columnGroupId, ...ungrouped } = promoted;
          const documentValueGetter = ungrouped._valueGetter as ((row: any) => unknown) | undefined;
          const documentFormatter = ungrouped.formatter as
            | ((d: number, p: number, a: unknown, b: unknown, row: any) => unknown)
            | undefined;
          ordered.unshift({
            ...ungrouped,
            initiallyHidden: false,
            _valueGetter: (row: any) => (hasDocumentNumber(row) ? documentValueGetter?.(row) : row?.name),
            formatter: (d: number, p: number, a: unknown, b: unknown, row: any) =>
              hasDocumentNumber(row) ? documentFormatter?.(d, p, a, b, row) : nameTemplate(row),
          });
        }
      }
    }

    const identityIndex = showDocumentNumberAsIdentity ? 0 : ordered.findIndex((col: any) => col?.id === "name");
    const revisionIndex = ordered.findIndex((col: any) => col?.id === "revision");
    if (identityIndex > -1 && revisionIndex > identityIndex + 1) {
      const revisionColumn = ordered.splice(revisionIndex, 1)[0];
      if (revisionColumn) ordered.splice(identityIndex + 1, 0, revisionColumn);
    }
    return ordered;
  };
  const gridColumns = buildGridColumns();

  const getUploadDropDown = () => {
    const permissionCheck = getPermission();
    return (
      <Box className="border border-button_light rounded">
        <ButtonComponent
          onClick={handleClick}
          buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
          endIcon={<KeyboardArrowDownIcon />}
        >
          <span className="flex items-center gap-2">
            <IconComponent name="upload" width="1rem" height="1rem" />
            <Text data-testid="addNewFileBtn">{t("New")}</Text>
          </span>
        </ButtonComponent>
        <Menu
          id="fade-menu"
          slotProps={{
            list: {
              "aria-labelledby": "fade-button",
            },
          }}
          slots={{ transition: Fade }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          {dropDownButtonItems.map((item: any) =>
            item.seperator ? (
              <Divider key={item.id} sx={{ margin: "0px !important" }} />
            ) : item.hasSubmenu ? (
              <MenuItem
                sx={{ fontSize: "0.875rem", paddingBottom: "0.5rem !important", paddingTop: "0.5rem !important" }}
                key={item.id}
                onMouseEnter={handleImportSubmenuOpen}
                onClick={handleImportSubmenuOpen}
              >
                <span className="flex items-center gap-2 w-full justify-between">
                  <span className="flex items-center gap-2">
                    <IconComponent name={item.iconName} width="1rem" height="1rem" />
                    {item.text}
                  </span>
                  <ChevronRightIcon fontSize="small" />
                </span>
              </MenuItem>
            ) : (
              <MenuItem
                sx={{ fontSize: "0.875rem", paddingBottom: "0.5rem !important", paddingTop: "0.5rem !important" }}
                key={item.id}
                onClick={(args) => {
                  if (isFileVersionUploading) {
                    dispatch(
                      showToastNotification({
                        content: t("Please close other upload operations before proceeding!"),
                        type: TOAST_TYPE_ERROR,
                      }),
                    );
                  } else {
                    if (!permissionCheck) {
                      dispatch(
                        showToastNotification({
                          content: t("Insufficient permission"),
                          type: TOAST_TYPE_ERROR,
                        }),
                      );
                      return;
                    }
                    handleSelectOption({ ...args, item });
                  }
                  handleClose();
                }}
              >
                <span className="flex items-center gap-2">
                  <IconComponent name={item.iconName} width="1rem" height="1rem" />
                  {item.text}
                </span>
              </MenuItem>
            ),
          )}
        </Menu>
        {/* Import submenu */}
        <Menu
          anchorEl={importSubmenuAnchor}
          open={importSubmenuOpen}
          onClose={handleImportSubmenuClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          MenuListProps={{ onMouseLeave: handleImportSubmenuClose }}
        >
          {dropDownButtonItems
            .find((item: any) => item.id === "import")
            ?.subItems?.map((subItem: any) => (
              <MenuItem
                sx={{ fontSize: "0.875rem", paddingBottom: "0.5rem !important", paddingTop: "0.5rem !important" }}
                key={subItem.id}
                onClick={(args) => {
                  if (isFileVersionUploading) {
                    dispatch(
                      showToastNotification({
                        content: t("Please close other upload operations before proceeding!"),
                        type: TOAST_TYPE_ERROR,
                      }),
                    );
                  } else {
                    if (!permissionCheck) {
                      dispatch(
                        showToastNotification({
                          content: t("Insufficient permission"),
                          type: TOAST_TYPE_ERROR,
                        }),
                      );
                      return;
                    }
                    handleSelectOption({ ...args, item: subItem });
                  }
                  handleClose();
                }}
              >
                <span className="flex items-center gap-2">
                  <IconComponent name={subItem.iconName} width="1rem" height="1rem" />
                  {subItem.text}
                </span>
              </MenuItem>
            ))}
        </Menu>
      </Box>
    );
  };

  const getToolBarItems = () => {
    let toolbar: any[] = [];
    if (fileManagerAsPopup) {
      toolbar = [
        {
          text: t("Refresh"),
          id: "refresh",
          iconName: "refresh",
          align: "left",
          show: toolBarBtnState.refresh,
        },
      ];
    } else if (selectedTab == TAB_THIS_SPACE) {
      toolbar = [
        {
          text: "Upload",
          id: "upload",
          align: "left",
          show: toolBarBtnState.upload,
          template: getUploadDropDown(),
        },
        {
          text: t("Refresh"),
          id: "refresh",
          iconName: "refresh",
          align: "left",
          show: toolBarBtnState.refresh,
          ["data-testid"]: "refreshFileManagerList",
        },
        {
          text: t("Delete"),
          id: "delete",
          iconName: "delete",
          align: "left",
          show: toolBarBtnState.delete,
          ["data-testid"]: "deleteFileOrFolder",
        },
        {
          text: t("Rename"),
          id: "rename",
          iconName: "edit",
          align: "left",
          show: toolBarBtnState.rename,
          ["data-testid"]: "renameFileOrFolder",
        },
        {
          text: t("Download"),
          id: "download",
          iconName: "download",
          align: "left",
          show: toolBarBtnState.download,
          ["data-testid"]: "downloadFileOrFolder",
        },
        {
          show: toolBarBtnState.details,
          align: "right",
          template: (
            <IconComponent
              onClick={handleDetailIconClick}
              name="details"
              width="1.5rem"
              height="1.5rem"
              dataTestId="filesDetails"
            />
          ),
        },
        {
          show: (window as any).electronAPI,
          align: "right",
          template: (
            <FolderSyncTemplate
              spaceId={spaceId}
              projectId={projectId}
              spaceData={spaceData}
              currentFolder={currentFolder}
            />
          ),
        },
      ];
    } else if (selectedTab == TAB_EXTERNAL_SPACE) {
      toolbar = [
        {
          text: t("Refresh"),
          id: "refresh",
          iconName: "refresh",
          align: "left",
          show: toolBarBtnState.refresh,
        },
        {
          text: t("Consume"),
          id: "consume",
          iconName: "consume",
          align: "left",
          show: toolBarBtnState.consume,
        },
        {
          id: "createNewShortcut",
          text: t("Create new shortcut"),
          iconName: "shortcut",
          align: "left",
          show: toolBarBtnState.createNewShortcut,
        },
        {
          show: toolBarBtnState.details,
          align: "right",
          template: <IconComponent onClick={handleDetailIconClick} name="details" width="1.5rem" height="1.5rem" />,
        },
      ];
    }
    return toolbar;
  };

  const toolbarItems = getToolBarItems();

  const headerTabs: any[] = [
    {
      id: TAB_THIS_SPACE,
      name: window.location.host.includes("dpmsportal") ? `This ${modulesNameSynonymMapper.space}` : t("This Space"),
      active: selectedTab == TAB_THIS_SPACE,
      onClick: () => handleFileManagerTabClick(TAB_THIS_SPACE),
      align: "left",
      dataTestId: "ThisSpaceTab",
      allow: true,
    },
    {
      id: TAB_EXTERNAL_SPACE,
      name: t("External"),
      active: selectedTab == TAB_EXTERNAL_SPACE,
      onClick: () => handleFileManagerTabClick(TAB_EXTERNAL_SPACE),
      align: "left",
      dataTestId: "ExternalTab",
      allow: layout.TRANSMITTAL?.ENABLE && !hideExternalSpace,
    },
    {
      id: TAB_REVIEWS,
      name: t("Reviews"),
      active: selectedTab == TAB_REVIEWS,
      onClick: () => handleFileManagerTabClick(TAB_REVIEWS),
      align: "left",
      dataTestId: "Reviews",
      allow: !hideReviews,
    },
    {
      allow: enableSpaceListDropdown,
      component: (
        <Box>
          <AutoComplete
            options={spaceList || []}
            valueField="id"
            getOptionLabel={(option) => option?.spaceName || ""}
            onChange={(_event, newValue) =>
              handleSpaceSelect({ isInteracted: true, value: newValue?.id, itemData: newValue })
            }
            value={(spaceList || []).find((opt: any) => opt.id === spaceId) || null}
            noOptionsText={t("No Spaces Found")}
            renderInput={(params) => <TextFieldComponent {...params} placeholder={t("Select Space")} />}
            sx={{ width: "17.0625rem" }}
          />
        </Box>
      ),
      align: "left",
    },
    {
      allow: process.env.REACT_APP_ENV == "qa" && userDetails?.email != "abdelrahman.abouhadid@macegroup.com",
      align: "right",
      id: "meet",
      name: "Meet",
      dataTestId: "meet",
      icon: "meeting",
      onClick: () => window.open("https://meet.techture.global", "_blank"),
    },
    {
      allow: process.env.REACT_APP_ENV == "qa" && userDetails?.email != "abdelrahman.abouhadid@macegroup.com",
      align: "right",
      id: "chat",
      name: "Chat",
      dataTestId: "chat",
      onClick: () => window.open("https://chat.cube.ms", "_blank"),
      icon: "Chat",
    },
    {
      align: "right",
      allow: layout.WORKSPACE_SETTINGS?.ENABLE_HIDDEN_ITEMS_CHECKBOX,
      component: (
        <Box id="toggleExtraDivToFixSwitchComp" className="flex items-center gap-3">
          <ToggleSwitchComponent
            id="toggleBtn"
            checked={getSpaceToggle.toggle}
            onChange={handleSpaceToggle}
            data-testid="SpaceToggleButton"
          />
          <Box data-testid="ShowHiddenItemsText">
            <Text>{t("Show hidden items")}</Text>
          </Box>
        </Box>
      ),
    },
  ];

  const getHeaderTabs = () => {
    const leftTabs = headerTabs.filter((tab: any) => tab.allow && tab.align === "left");
    const rightTabs = headerTabs.filter((tab: any) => tab.allow && tab.align === "right");

    return (
      <Box className="w-full items-center border-b border-b-button_light">
        <Tabs
          value={selectedTab}
          className="w-full flex gap-5 ps-5 pe-5"
          sx={{
            "& .MuiTabs-flexContainer": {
              gap: "2.5rem",
            },
          }}
        >
          {leftTabs.map((tab: any, index: number) =>
            tab.component ? (
              <React.Fragment key={tab.id || `left-tab-${index}`}>{tab.component}</React.Fragment>
            ) : (
              <Tab
                key={tab.id}
                value={tab.id}
                label={
                  <Box className="flex items-center gap-1">
                    {tab.icon && <IconComponent name={tab.icon} width="1.5rem" height="1.5rem" />}
                    <Text>{tab.name}</Text>
                  </Box>
                }
                onClick={tab.onClick}
                data-testid={tab.dataTestId}
              />
            ),
          )}
          <span className="flex-1" />
          {rightTabs.map((tab: any, index: number) =>
            tab.component ? (
              <React.Fragment key={tab.id || `right-tab-${index}`}>{tab.component}</React.Fragment>
            ) : (
              <Tab
                key={tab.id}
                value={tab.id}
                label={
                  <Box className="flex items-center gap-1">
                    {tab.icon && <IconComponent name={tab.icon} width="1.5rem" height="1.5rem" />}
                    <Text>{tab.name}</Text>
                  </Box>
                }
                onClick={tab.onClick}
                data-testid={tab.dataTestId}
                className={tab.active ? "font-bold" : ""}
              />
            ),
          )}
        </Tabs>
      </Box>
    );
  };

  const getContent = () => {
    if (spaceData?.noAccess) {
      return <Forbidden />;
    } else if ((selectedTab == TAB_THIS_SPACE || selectedTab == TAB_EXTERNAL_SPACE) && spaceData?.id) {
      return (
        <>
          {selectedTab == TAB_EXTERNAL_SPACE && emptyExternal && (
            <Box className="flex flex-col gap-10 bottom-0 top-14 absolute bg-white z-20 w-full justify-center items-center">
              <Box className="flex items-center justify-center flex-col">
                <IconComponent name="NoData" width="18.75rem" height="18.8125rem" />
                <Box className="font-semibold text-lg">
                  <Text>{"No Data"}</Text>
                </Box>
              </Box>
              <ButtonComponent onClick={handleNoDataRefresh}>
                <Text>{t("Refresh")}</Text>
              </ButtonComponent>
            </Box>
          )}
          {selectedTab == TAB_THIS_SPACE && emptyThisSpace && (
            <Box
              className="flex flex-col absolute bg-white top-14 z-20 w-full items-center justify-center bottom-0"
              onDragOver={handleEmptyStateDragOver}
              onDragEnter={handleEmptyStateDragOver}
              onDrop={handleEmptyStateDrop}
            >
              <span>
                <IconComponent name="NoFilesIllustration" width="18.75rem" height="22.5rem" />
              </span>
              {!fileManagerAsPopup && getUploadDropDown()}
            </Box>
          )}
          <FileManagerComponent
            contextMenuSettings={{
              file: fileManagerOptionsMapper[selectedTab].fileOptions,
              folder: fileManagerOptionsMapper[selectedTab].folderOptions,
              layout: fileManagerOptionsMapper[selectedTab].layoutOptions,
              visible: !disableContextMenu,
            }}
            disableDragAndDropUpload={disableDragAndDropUpload}
            menuOpen={menuOpen}
            path={path!}
            showFolderTree={showFolderTree}
            beforeSending={beforeSending}
            onFileLoad={onFileLoad}
            onSuccess={onSuccess}
            allowDragAndDropUpload={selectedTab == TAB_THIS_SPACE && !layout?.FILE_MANAGER?.IMPORT_ONLY_UPLOADS}
            fileColumns={gridColumns}
            defaultPinnedColumns={pinnedColumnIds}
            setCurrentFolder={setCurrentFolder}
            ref={fileManagerRef}
            toolbarClick={toolbarClick}
            toolbarItems={toolbarItems}
            allowViewFileOptions={true}
            fileManagerData={fileManagerDataWithDisabled}
            setFileManagerData={setFileManagerData}
            onFileClick={onFileClick}
            onFileSelect={onFileSelect}
            preSearchText={preSearchText ?? undefined}
          />
        </>
      );
    } else if (selectedTab == TAB_REVIEWS && spaceData?.id) {
      return <ReviewsList spaceId={spaceId} archiveToggle />;
    } else {
      return "";
    }
  };

  const newContainerCreateModal = () => (
    <Box className="w-full">
      <Box className="my-4">
        <Text>{t("Format")}</Text>
        <Box className="mt-2">
          <FormControl
            fullWidth
            sx={{
              "& .MuiInputBase-root": {
                height: "2rem",
              },
            }}
          >
            <Select
              value={resourceType?.text}
              onChange={(e) => {
                setFileTypeValue("");
                setResourceType({ text: (e.target as any).text, value: e.target.value });
              }}
            >
              <MenuItem value="RESOURCE_TYPE_FILE">
                <Text>{t("File")}</Text>
              </MenuItem>
              <MenuItem value="RESOURCE_TYPE_EMBED">
                <Text>{t("Embed")}</Text>
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
      <Box className="my-4">
        <Text> {t("Name")} </Text>
        {currentFolder?.fileNomenclature?.fields?.length ? (
          <Box className="mt-2 flex gap-2">
            {currentFolder.fileNomenclature.fields.map((field: any, index: number) => (
              <NomenclatureField
                key={`${field._id}-${index}`}
                args={{ id: 1 }}
                field={field}
                index={index}
                value={nomenclatureValues[index] ?? ""}
                handleNomenclatureChange={handleNomenclatureChange}
              />
            ))}
          </Box>
        ) : (
          <Box className="mt-2">
            <TextFieldComponent onChange={handleContainerName} placeholder={t("Container Name")} />
          </Box>
        )}
      </Box>
      {resourceType.value == "RESOURCE_TYPE_EMBED" && (
        <Box className="my-4">
          <Text>{t("URL")}</Text>
          <Box className="mt-2">
            <TextFieldComponent onChange={handleEmbedUrl} placeholder={t("Embed URL")} />
          </Box>
        </Box>
      )}
      {resourceType.value == "RESOURCE_TYPE_FILE" && (
        <>
          <Box className="my-4">
            <Text>{t("File Type")}</Text>
            <Box className="mt-2">
              <AutoComplete
                options={containerFileTypes.map((x: string) => ({ text: x }))}
                valueField="text"
                getOptionLabel={(option) => option?.text || ""}
                value={
                  containerFileTypes.map((x: string) => ({ text: x })).find((opt: any) => opt.text === fileTypeValue) ||
                  null
                }
                onChange={(_event, newValue) => {
                  setFileTypeValue(newValue?.text ?? null);
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props} className="flex items-center gap-1 mt-1">
                    <span className="mb-1 flex">{getFileIcon(option.text)}</span>
                    <span>
                      <Text>{option.text}</Text>
                    </span>
                  </Box>
                )}
                renderInput={(params) => <TextFieldComponent {...params} placeholder={t("Select file Type")} />}
              />
            </Box>
          </Box>
          <Box className="my-4">
            {containerFormTemplate && (
              <FormPreview
                formData={{ template: containerFormTemplate }}
                disabled={false}
                allowPadding={false}
                allowBorder={false}
                fullWidthInput
                removeIcons
                handleData={handleCustomFieldsData}
                formValidator={formValidator}
              />
            )}
          </Box>
        </>
      )}
    </Box>
  );

  const getRenameModal = () => (
    <ModalStateDialogComponent
      footerContent={
        <Box className="flex w-full gap-4">
          <ButtonComponent
            onClick={handleSaveNewName}
            disabled={!newName.trim() || hasInvalidChars(newName)}
            buttonType="gradientButton"
            data-testid="saveNewName"
          >
            <Text>{t("Save")}</Text>
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              setOpenRenameModal(false);
              setNewName("");
            }}
            buttonType="borderButton"
            data-testid="cancelNewName"
          >
            <Text>{t("Cancel")}</Text>
          </ButtonComponent>
        </Box>
      }
      onCancel={() => {
        setOpenRenameModal(false);
      }}
      headerTitle={t("Rename")}
      modelContent={
        <div className="w-full flex flex-col gap-1">
          <TextFieldComponent
            onChange={(args) => setNewName(args.target.value)}
            placeholder={t("Enter a new name")}
            value={newName}
            data-testid="enterNewName"
          />
          {hasInvalidChars(newName) && (
            <Text className="text-red-600 whitespace-normal text-xs">
              {t(
                'The file or folder name contains invalid characters. Please use a different name. Valid file or folder name cannot end with a dot or space, and cannot contain any of the following characters: \\ / : * ? " < > |',
              )}
            </Text>
          )}
        </div>
      }
      isVisible={openRenameModal.state}
      width="25%"
      allowModalPadding
    />
  );

  const getFolderCreationModal = () => (
    <ModalStateDialogComponent
      footerContent={
        <Box className="flex w-full gap-4">
          <ButtonComponent
            onClick={handleCreateFolder}
            disabled={!folderName?.trim() || hasInvalidChars(folderName)}
            buttonType="gradientButton"
            data-testid="createFolderBtn"
          >
            <Text>{t("Create")}</Text>
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              handleCloseFolder();
            }}
            buttonType="borderButton"
            data-testid="discardFolderBtn"
          >
            <Text>{t("Discard")}</Text>
          </ButtonComponent>
        </Box>
      }
      onCancel={handleCloseFolder}
      headerTitle={t("New Folder")}
      modelContent={
        <div className="w-full flex flex-col gap-1">
          <TextFieldComponent
            onChange={handleFolderName}
            placeholder={t("Enter your folder name")}
            data-testid="enterFolderName"
          />
          {hasInvalidChars(folderName) && (
            <Text className="text-red-600 whitespace-normal text-xs">
              {t(
                'The file or folder name contains invalid characters. Please use a different name. Valid file or folder name cannot end with a dot or space, and cannot contain any of the following characters: \\ / : * ? " < > |',
              )}
            </Text>
          )}
        </div>
      }
      isVisible={openFolderCreationModal}
      width="25%"
      allowModalPadding
    />
  );

  const getContainerModal = () => (
    <ModalStateDialogComponent
      footerContent={
        <Box className="flex w-full gap-4">
          <ButtonComponent
            onClick={handleCreateContainer}
            disabled={containerName.trim() == "" || !fileTypeValue}
            buttonType="gradientButton"
          >
            <Text>{t("Create")}</Text>
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              handleModalClose();
            }}
            buttonType="borderButton"
          >
            <Text>{t("Discard")}</Text>
          </ButtonComponent>
        </Box>
      }
      headerTitle={t("New Container")}
      onCancel={handleModalClose}
      modelContent={newContainerCreateModal()}
      isVisible={openContainerModal}
      width="60%"
      allowModalPadding
    />
  );

  const getFileManagerPopup = () => {
    const selectedFiles = getSelectedFilesInFileManager();

    if (openFileImport) {
      return (
        <FileManagerAsPopup
          projectId={projectId}
          handleFileSelectedButtonClick={handleFileImportCallback}
          handleFileSelectedCancelClick={closeFileImportPopup}
          workspaceId={spaceId}
          id="fileManagerAsPopup"
          useAttachedExternalVolume
          disableContextMenu
          heading={t("Import Files")}
          hideAllTabs
          minimumFiles={0}
        />
      );
    } else if (openMergeEstimateModal) {
      return (
        <FileManagerAsPopup
          projectId={projectId}
          handleFileSelectedButtonClick={createMergeEstimateModal}
          handleFileSelectedCancelClick={closeMergeEstimateModal}
          workspaceId={spaceId}
          id="fileManagerAsPopup"
          hideIssues
          hideTasks
          hideClashTests
          hideSchedules
          hideContracts
          heading={t("Merged Estimates")}
          allowInput
          inputLabel="Merged Estimate Name"
          minimumFiles={0}
          selectedFilesData={selectedFiles}
          createMerge
        />
      );
    } else if (openMergeModal) {
      return (
        <FileManagerAsPopup
          projectId={projectId}
          handleFileSelectedButtonClick={saveFileMergeModal}
          handleFileSelectedCancelClick={closeFileMergeModal}
          workspaceId={spaceId}
          id="fileManagerAsPopup"
          hideIssues
          hideTasks
          hideClashTests
          hideSchedules
          hideContracts
          hideReviews
          hideAllTabs
          heading={t("Merge")}
          allowInput
          inputLabel="Name"
          minimumFiles={0}
          selectedFilesData={selectedFiles}
          createMerge
          addEmptyContainerToList
        />
      );
    } else if (openFileModalExternal) {
      return (
        <FileManagerAsPopup
          projectId={projectId}
          handleFileSelectedCancelClick={closeCreateShortcutModal}
          workspaceId={spaceId}
          id="fileManagerAsPopup"
          hideIssues
          hideTasks
          heading={openFileModalExternal == "shortcut" ? t("Create Shortcut") : t("Consume File(s)")}
          hideEstimates
          hideSchedules
          hideContracts
          hideExternalSpace
          hideReviews
          createShortcut
          consumeFiles={openFileModalExternal == "consume"}
          shortCutData={shortCutData}
          externalFolderData={{
            _id: currentFolder.transmittalVersionId,
            indexAtProjectLevel: currentFolder.transmittalCounter,
          }}
        />
      );
    } else {
      return "";
    }
  };

  return (
    <Box className="w-full h-full flex relative bg-white flex-col" data-testid="filemanagerComponentRoot">
      {!hideAllTabs && getHeaderTabs()}
      {getContent()}
      {openDeleteConfirmationModal && (
        <FileDelete
          workspaceId={spaceId}
          selectedFiles={selectedFilesToDelete}
          onCloseModal={handleDeleteModalClose}
          onDeleteSuccess={handleDeleteSuccess}
          path={path}
        />
      )}
      {showContainerImportModal && (
        <ExcelImport
          showImportModal={showContainerImportModal}
          setShowImportModal={setShowContainerImportModal}
          source={excelImportSources.FILES}
          sourceId="a"
          refreshDataGrid={reloadFileManager}
          importMode={importMode}
          currentData={{
            projectId,
            hierarchyId: currentFolder.hierarchyId,
            parentId: currentFolder.hierarchyId,
            spaceId,
            folderName: currentFolder.name,
            filterPath: currentFolder.filterPath,
          }}
        />
      )}
      {openRenameModal.state && getRenameModal()}
      {openCreateTransmittalModal && (
        <CreateTransmittal
          isOpen={openCreateTransmittalModal}
          onClose={() => setOpenCreateTransmittalModal(false)}
          projectId={projectId}
          selectedSpaceId={spaceId}
          selectedReferences={selectedFile}
        />
      )}
      {createReviewModal.show && (
        <CreateReviewModal
          spaceId={spaceId}
          refreshGrid={reloadFileManager}
          closeModal={closeReviewModal}
          projectId={projectId}
          initialFiles={getSelectedFilesInFileManager()}
        />
      )}
      {openContainerModal && getContainerModal()}
      {openFolderCreationModal && getFolderCreationModal()}
      {(openFileImport || openMergeEstimateModal || openMergeModal || openFileModalExternal) && getFileManagerPopup()}
    </Box>
  );
});

FileManager.displayName = "FileManager";

export default FileManager;
